import httpInstance from '../httpInstance';

const getCurrentVersionsService = async () => {
  const endpoint = '/back-office/v1/commerce-version/get-minimum';
  const res = await httpInstance.get(endpoint);
  return res;
};

export default getCurrentVersionsService;
